@if (!dialogOnly() && events().length) {
  <section class="template-fields">
    <h3>{{ 'Notification template fields' | translate }}</h3>
    @for (event of events(); track event.key) {
      <div class="template-fields__event">
        <p class="template-fields__name">{{ event.displayName | translate }}</p>
        <p class="template-fields__key">{{ event.key }}</p>
        @if (event.templates.length) {
          <ul class="template-fields__templates">
            @for (template of event.templates; track template.id) {
              <li>
                <span>{{ template.name }}</span>
                @if (showTemplateList()) {
                  <app-secondary-button
                    title="Edit template"
                    size="small"
                    (action)="expandedTemplateId.set(template.id)"
                  ></app-secondary-button>
                }
              </li>
            }
          </ul>
        } @else if (showTemplateList()) {
          <p class="template-fields__list">{{ 'No notification templates for this event' | translate }}</p>
        }
        @if (!showTemplateList()) {
        <ul class="template-fields__tokens">
          @for (token of event.tokens; track token) {
            <li><code>{{ token }}</code></li>
          }
        </ul>
        @for (list of event.lists; track list.name) {
          <p class="template-fields__list">{{ 'Notification template list row' | translate: { name: list.name } }}</p>
          <ul class="template-fields__tokens">
            @for (token of list.tokens; track token) {
              <li><code>{{ token }}</code></li>
            }
          </ul>
        }
        }
      </div>
    }
  </section>
} @else if (!dialogOnly() && !hideWhenEmpty()) {
  <p class="template-fields__empty">{{ 'No notification template fields' | translate }}</p>
}

<p-dialog
  [visible]="openedTemplate() !== null"
  (visibleChange)="!$event && closeTemplate()"
  [header]="openedTemplate()?.template?.name ?? ''"
  [modal]="true"
  [style]="{ width: '40rem' }"
  [contentStyle]="{ display: 'flex', 'min-height': '70vh' }"
>
  @if (openedTemplate(); as opened) {
    <div class="template-dialog">
    <section class="template-fields__variables-block">
      <h3>{{ 'Template variables' | translate }}</h3>
      <table class="template-fields__variables">
        <tbody>
          @for (variable of openedVariables(); track variable.token) {
            <tr>
              <td><code>{{ variable.token }}</code></td>
              <td>{{ variable.descriptionKey | translate }}</td>
            </tr>
          }
        </tbody>
      </table>
    </section>
    @if (openedModel(); as model) {
      <div class="template-fields__models">
        <p class="template-fields__model">
          <span>{{ 'Template model namespace' | translate }}</span>{{ model.namespace }}
        </p>
        <p class="template-fields__model">
          <span>{{ 'Template model class' | translate }}</span>{{ model.className }}
        </p>
        <p class="template-fields__model">{{ model.className }}.{{ model.method }}</p>
      </div>
    }
    <p-tabs [value]="draftLanguage()" (valueChange)="setDraftLanguage($event)">
      <p-tablist>
        @for (language of languages; track language) {
          <p-tab [value]="language">{{ language }}</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        @for (language of languages; track language) {
          <p-tabpanel [value]="language">
            @if (draftLanguage() === language) {
              <msf-input
                [model]="activeTitle()"
                (modelChange)="setActiveTitle($event)"
                [label]="'Template title' | translate"
              ></msf-input>
              <app-textarea
                [ngModel]="activeBody()"
                (ngModelChange)="setActiveBody($event)"
                label="Template body"
                [rows]="8"
                [showCharacterCount]="false"
              ></app-textarea>
            }
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
    @if (saveFailed()) {
      <p class="template-fields__error">{{ 'adminNotifications.saveFailed' | translate }}</p>
    }
    <div class="template-dialog__actions">
      <app-save-button [isSaving]="saving()" (save)="saveTemplate()"></app-save-button>
    </div>
    </div>
  }
</p-dialog>
